import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import withWidth from 'material-ui/utils/withWidth'

import IframeResizer from 'react-iframe-resizer-super';
import Breakpoint from '../../utils/breakpoints';
import SectionHeader, {
} from '../../components/layouts/SectionHeader';

import withWidthNumber from '@src/utils/withWidthNumber';

const iframeResizerOptions = {
    checkOrigin: false,
    log: false,
};

function YellowfinIframe(props) {
    const {width, yfheight } = props
    const iFrameStyle = {
      width: '1294px',
      display: (width && width > 1024) ? 'block': 'none'
    }

    if(yfheight && yfheight !== null && yfheight > 0){
      iFrameStyle.minHeight = yfheight
    }
    return (
        <SectionHeader margin="0 0 20px 0">
            <IframeResizer
              src={props.iframeUrl}
              minWidth={1294}
              maxWidth={1294}
              iframeResizerOptions={iframeResizerOptions}
              style={iFrameStyle}
            />
            <Breakpoint name="mobile">
                <p> You're current screen size is not yet supported. For best viewing experience please visit on a desktop or a landscape IPad Pro </p>
            </Breakpoint>
            <Breakpoint name="tablet">
              <p> You're current screen size is not yet supported. For best viewing experience please visit on a desktop or a landscape IPad Pro </p>
            </Breakpoint>

        </SectionHeader>
    );
}

export default withWidthNumber(YellowfinIframe);



// WEBPACK FOOTER //
// ./src/features/yellowfin/YellowfinIframe.js